import { combineReducers } from 'redux';
import { AppState, appReducer } from './app.reducer';
import { userReducer } from './user.reducer';
import { User } from '../../types/user.types';

export interface RootState {
  user: User;
  app: AppState;
}

export const rootReducer = combineReducers({
  user: userReducer,
  app: appReducer,
});
